import React from 'react'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { useGiveawayContext } from '../../context/GiveawayContext'
import GiveawayHero from '../Hero/GiveawayHero'
import { LearnMoreButton } from '../Hero/LearnMoreButton'
import { BackgroundLinearGradient } from './BackgroundLinearGradient'
import { BackgroundVideo } from './BackgroundVideo'
import { GiveawayNav } from './GiveawayNav'

export const GiveawayHeader: React.FC = () => {
  const { content, isBackgroundVideoPaused, heroContainerRef } = useGiveawayContext()
  const { hero } = content

  return (
    <header
      ref={heroContainerRef}
      className="relative flex min-h-dvh flex-col bg-black p-6 md:h-[856px] md:min-h-full md:bg-center"
    >
      {hero?.desktopImageUrl && hero.mobileImageUrl && (
        <ResponsiveBackgroundImage
          srcUrls={{
            xs: hero.mobileImageUrl,
            sm: hero.mobileImageUrl,
            md: hero.desktopImageUrl,
            lg: hero.desktopImageUrl,
            xl: hero.desktopImageUrl,
            '2xl': hero.desktopImageUrl,
          }}
          src={hero.mobileImageUrl}
        />
      )}
      <BackgroundLinearGradient />
      {hero?.backgroundVideoUrl && (
        <BackgroundVideo paused={isBackgroundVideoPaused} videoSrc={hero.backgroundVideoUrl} />
      )}
      <GiveawayNav />
      <GiveawayHero />
      <LearnMoreButton />
    </header>
  )
}
